/* get the json file for the cart */
var $cart_js_url = window.location.protocol + '//' + window.location.hostname + '/cart.js';
if( typeof $jq !== 'undefined'){
	$jq.ajax({ url: $cart_js_url, dataType: 'json' }).done(function( e ){
    
    		var donation_product = { exists: false };
      
     		var donation_products_available = pd_object.product_assigned;

					$jq.each( donation_products_available, function(k,v){
						if( typeof v !== 'number' ){
						donation_products_available[k] = parseInt( v );
						}
					});
					$jq.each( e.items, function(k,v){

						if( $jq.inArray( v.product_id, donation_products_available ) >= 0 ){
							donation_product.exists = true;
							if( typeof donation_product.total === 'undefined' ){
								donation_product.total = v.line_price;
							}else{
								donation_product.total = donation_product.total + v.line_price;
							}
						}
					});
					
      if( donation_product.exists ){ 
        $jq('.parkinsons-donations').addClass('active');
        var giftAidScripts = $jq('.parkinsons-donations').find('.gift-aid-scripts');
        var giftAidInfo = $jq(giftAidScripts).data('gift-aid-info');
        var giftAidIntro = Handlebars.compile($jq(giftAidScripts).find('.declaration').html());
        var giftAidIntro = giftAidIntro( giftAidInfo );
        $jq('.parkinsons-donations').find('.gift-aid-declaration').html( giftAidIntro );
      }else{
      	$jq('.parkinsons-donations').addClass('active');
        
      }
    
    
    /* End Ajax */
    });
    

  $jq(document).ready(function(){
  	
    $jq('body').on('click', '.pd-add', function(){
    	var $parent_container = $jq(this).closest('.parkinsons-donations');
      	if( $jq(this).hasClass('active') ){
      		$jq(this).removeClass('active');
            $jq('.pd-box').attr('tabindex', '0');
            $jq('.pd-box').attr('aria-pressed', 'false');
          	$jq($parent_container).find('.pd-container-inner').removeClass('active');
        }else{
            $jq('.pd-box').attr('tabindex', '-1');
            $jq('.pd-box').attr('aria-pressed', 'false');
	        $jq($parent_container).find('.pd-add, .pd-add-other').removeClass('active');
          	$jq($parent_container).find('.pd-container-inner').addClass('active');          
        	$jq(this).addClass('active');
            $jq(this).attr('tabindex', '0');
            $jq(this).attr('aria-pressed', 'true');
        }
    });

    $jq('body').on('click', '.pd-add-other .pd-box', function(){
    	var $parent_container = $jq(this).closest('.parkinsons-donations');
      	if( $jq(this).closest('.pd-add-other').hasClass('active') ){
      		$jq(this).closest('.pd-add-other').removeClass('active');
          	$jq($parent_container).find('.pd-container-inner').removeClass('active');
            $jq('.pd-box').attr('tabindex', '0');
            $jq('.pd-box').attr('aria-pressed', 'false');
        }else{
            $jq('.pd-box').attr('tabindex', '-1');
            $jq('.pd-box').attr('aria-pressed', 'false');
	        $jq($parent_container).find('.pd-add, .pd-add-other').removeClass('active');
          	$jq($parent_container).find('.pd-container-inner').addClass('active'); 
        	$jq(this).closest('.pd-add-other').addClass('active');
            $jq(this).attr('tabindex', '0');
            $jq(this).attr('aria-pressed', 'true');
        }
    });    
    
    $jq('body').on('click', '.pd-submit', function(){
      	
      var $parent_container = $jq(this).closest('.parkinsons-donations');
      
      if( typeof $jq($parent_container).find('.pd-add.active, .pd-add-other.active')[0] === 'undefined' ){
        return;
      }
      
      var $current_active = $jq($parent_container).find('.pd-add.active, .pd-add-other.active');
      var donation_product_object = {};
      if( $jq( $current_active ).hasClass('pd-add') ){
      	donation_product_object.quantity = 1;
        donation_product_object.id = $jq( $current_active ).data('variant-id');
      }else{
        console.log($current_active);
      	donation_product_object.quantity = $jq( $current_active ).find('.pd-box-value input').val() * 100;
        donation_product_object.id = $jq( $current_active ).data('variant-id');      
      }
          
      var new_donation_id = $jq.parseHTML('<input name="id" type="hidden" />');
      $jq(new_donation_id).val( donation_product_object.id );
      var new_donation_quantity = $jq.parseHTML('<input name="quantity" type="hidden" />');
      $jq(new_donation_quantity).val( donation_product_object.quantity );		
      var new_donation_form = $jq.parseHTML('<form class="donation-form-add" method="POST" action="/cart/add"></form>');
      $jq(new_donation_form).append(new_donation_id);
      $jq(new_donation_form).append( new_donation_quantity );
      $jq('body').append( new_donation_form );
      $jq('body').find('.donation-form-add').submit().remove();
   
    });

    $jq(document).on('keydown', function(evt){
      var currEle = $( document.activeElement );
      if (evt.which == '13' || evt.which == '32'){
        if( currEle.hasClass('pd-add') ){
          currEle.trigger('click');
        }
        if( currEle.hasClass('pd-box') && typeof currEle.closest('.pd-add-other')[0] !== 'undefined'){
          currEle.trigger('click');
        }
      }
    });
    
  });
  
}